<template>
	<div class="c-intro__wrapper">
		<transition name="fade-short" tag="div">
			<div :class="['c-intro']" v-if="active">
				<div class="c-intro__inner anim-hook">
					<div class="c-intro__header">
						<img src="/logo-big-white.svg" class="logo img-fluid" />
						<!-- <p class="p-small">
					<a href="https://underlineme.com" target="_blank">Homepage</a
					><span>&nbsp;•&nbsp;</span
					><a href="https://underlineme.com/contact" target="_blank">Support</a>
				</p> -->
						<span class="p-small">v{{ version }} - beta</span>
					</div>
					<transition name="fade" tag="div" mode="out-in">
						<div class="c-intro__body" v-if="area === ''" key="intro">
							<a
								class="btn btn-primary btn-fancy"
								href="#"
								@click.prevent="area = 'signup'"
							>
								Get Started
								<chevron-right-icon size="1.25x"></chevron-right-icon>
							</a>
							<hr />
							<a class="btn btn-fancy" href="#" @click.prevent="area = 'login'">
								Login
							</a>
						</div>
						<div class="c-intro__body" v-if="area === 'signup'" key="signup">
							<HeadlessSignup @success="onSignup"> </HeadlessSignup>
						</div>
						<div class="c-intro__body" v-if="area === 'login'" key="login">
							<Login @success="onLogin"> </Login>
							<p class="p-small">
								Please allow upto a minute to restore your notes.
							</p>
						</div>
					</transition>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
import { required, minLength, between } from 'vuelidate/lib/validators';
import queryString from 'query-string';

import HeadlessSignup from '@/components/forms/headless-signup';
import Login from '@/components/forms/login';
import { ChevronRightIcon } from 'vue-feather-icons';

import anime from 'animejs';

export default {
	components: {
		HeadlessSignup,
		Login,
		ChevronRightIcon,
	},

	data: function () {
		var obj = {
			active: false,
			area: 'signup',
			errorMessage: '',
			hasResetPasswordSubmit: false,
			hasSetpasswordSubmit: false,
			tabIndex: 0,
		};
		return obj;
	},

	validations: {
		loginForm: {
			username: {
				required,
				minLength: minLength(3),
			},
			password: {
				required,
				minLength: minLength(3),
			},
		},
		resetpasswordForm: {
			email: {
				required,
			},
		},
		setpasswordForm: {
			password: {
				required,
				minLength: minLength(8),
			},
			password2: {
				required,
				minLength: minLength(8),
			},
		},
	},

	watch: {
		active: function () {
			if (this.active) {
				setTimeout(() => {
					this.runAnimation();
				}, 500);
			}
		},
	},

	computed: {
		version: function () {
			return this.$store.getters.version;
		},
	},

	methods: {
		onResetpasswordSubmit: function () {
			this.$v.$touch();
			if (!this.$v.resetpasswordForm.$invalid) {
				this.submitResetpassword();
			}
		},
		onSetPasswordSubmit: function () {
			this.$v.$touch();
			if (
				!this.$v.setpasswordForm.$invalid &&
				this.setpasswordForm.password === this.setpasswordForm.password2
			) {
				this.submitSetpassword();
			}
		},
		submitSetpassword: function () {
			this.lock = true;
			this.$store
				.dispatch('user/changePasswordAndLogin', this.setpasswordForm)
				.then((status) => {
					if (status) {
						this.$bvModal.hide('modal-intro');
						let query = Object.assign({}, this.$route.query);
						delete query.reset;
						this.$router.replace({ query });
					}
					this.hasSetpasswordSubmit = true;
					this.lock = false;
				});
		},
		submitResetpassword: function () {
			this.lock = true;
			this.$store
				.dispatch('user/initiatePasswordReset', this.resetpasswordForm)
				.then(() => {
					this.hasResetPasswordSubmit = false;
					this.lock = false;
				});
		},
		submitLogin: function () {
			this.lock = true;
			this.$store
				.dispatch('user/login', this.loginForm)
				.then((res) => {
					this.$bvModal.hide('modal-intro');
					this.errorMessage = '';
					this.lock = false;
				})
				.catch((err) => {
					this.errorMessage =
						'No user with that email and password combination exists. Please enter re-enter your details';
					this.lock = false;
				});
		},
		runAnimation: function () {
			let animation = anime.timeline({
				duration: 500,
				complete: () => {},
			});
			animation.add({
				targets: '.anim-hook',
				opacity: [0, 1],
				scale: [0.925, 1],
				translateY: [12, 0],
				easing: 'cubicBezier(0.290, 0.950, 0.715, 1)',
			});

			animation.play();
		},
		onSignup: function () {
			this.$emit('showOnboarding');
			setTimeout(() => {
				this.active = false;
			}, 500);
		},
		async onLogin() {
			await this.$store.dispatch('block/insertOnboardingBlocks', null, {
				root: true,
			});
			this.$emit('showOnboarding');
			setTimeout(() => {
				this.active = false;
			}, 500);
		},
	},
	mounted: function () {
		if (!this.active) {
			this.active = true;
		}
	},
};
</script>

<style lang="scss">
.c-intro {
	display: flex;
	justify-content: center;
	align-items: center;
	position: fixed;
	z-index: calc(var(--z-2) + 50);
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: var(--g4);
	box-shadow: inset 0 0 32px 0 rgba(0, 0, 0, 0.125),
		inset 0 0 256px 0 rgba(0, 0, 0, 0.125);

	@include scrollBars();

	&:after {
		content: '';
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		pointer-events: none;
		background: linear-gradient(
			350deg,
			rgba(255, 255, 255, 0.01) 0%,
			rgba(255, 255, 255, 0.04) 70%
		);
	}

	.anim-hook {
		opacity: 0;
		transform: scale(0);
	}

	&__header {
		margin-bottom: var(--spacer);

		.logo {
			max-width: 200px;
			margin-bottom: 8px;
		}

		.p-small {
			display: block;
			text-align: center;
		}
	}

	&__body {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}

	.fade-short-leave-active {
		transition: opacity 300ms;
	}
	.fade-short-leave-to /* .fade-leave-active below version 2.1.8 */ {
		opacity: 0;
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 300ms cubic-bezier(0.115, 0.74, 0.245, 1);
	}
	.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
		opacity: 0;
	}

	&__inner {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		height: auto;
		max-width: 480px;
		padding: var(--spacer);
		margin: 0 auto;
		border-radius: 0;
		position: relative;
		background-color: transparent;
		border: none;
		overflow-y: auto;

		hr {
			width: 100%;
			margin: var(--spacer-sm);
			&:after {
				left: 20%;
				width: 60%;
			}
		}

		.nav-tabs {
			display: none;
		}
		&:after {
			content: none;
		}

		.spinner-border {
			vertical-align: baseline;
			display: inline-block;
			width: 2rem;
			height: 2rem;
			border: 0.25em solid;
			border-right: 0.25em solid transparent;
			border-radius: 50%;
			animation: spinner-border 0.75s linear infinite;
		}
		.spinner-border-sm {
			width: 12px;
			height: 12px;
			border-width: 2px;
		}

		// .tab-pane {
		// 	margin-top: var(--spacer);
		// }

		// .btn-fancy {
		// 	svg {
		// 		margin-left: 4px;
		// 		margin-right: -8px;
		// 		stroke-width: 3px;
		// 		transition: transform var(--transition-time) ease-out;
		// 	}

		// 	&:hover,
		// 	&:active {
		// 		svg {
		// 			transform: translateX(2px);
		// 		}
		// 	}
		// }

		@keyframes spinner-border {
			to {
				-webkit-transform: rotate(1turn);
				transform: rotate(1turn);
			}
		}
	}
}
</style>
